var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYsfHomePatternMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 775,
    viewBox: "0 0 375 775",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 406,
    r: 449.438,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.973,
    cy: 405.973,
    r: 380.356,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.838,
    cy: 405.842,
    r: 305.464,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.733,
    cy: 405.733,
    r: 228.312,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.04,
    cy: 406.049,
    r: 149.868,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYsfHomePatternMobile);
export default __webpack_public_path__ + "static/media/YSFHomePatternMobile.2fe6886f84ab617074ea28b9d0457add.svg";
export { ForwardRef as ReactComponent };